import React from 'react';
import * as Yup from "yup";
import { sortCaret } from "../../../../_metronic/_helpers";
import * as columnFormatters from "../../../../_metronic/layout/components/basePage/pages/objects-table/column-formatters";
import { Input } from "../../../../_metronic/_partials/controls";
import { SelectStatus } from '../../customComponents/SelectStatus';
import { SelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/SelectObjectsField';
import { FilterSelectObjectsField } from '../../../../_metronic/layout/components/basePage/selectObjects/FilterSelectObjectsField';


export const initObject = {
  id: undefined,
  answerTitle: "",
  answerId: 0,
  answerCode: 0,
  answerOrderInList: 0,
  answerType: 0,
  answerDefaultValue: "",
  questionId: 0,
  questionTitle: "",
  questionCode: 0,
  questionAnsweredType: 0,
  questionAllowedAnswer: 0,
  isDefault: false,
  isDeleted: false
};

export const columns = [
  {
    dataField: "answerTitle",
    text: "پاسخ",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "answerCode",
    text: "کد پاسخ",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "answerDefaultValue",
    text: "پیش فرض",
    sort: true,
    sortCaret: sortCaret,
  },
  // {
  //   dataField: "answerOrderInList",
  //   text: "اولویت",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  {
    dataField: "answerType",
    text: "نوع پاسخ",
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.AnswerTypeColumnFormatter,
  },
  {
    dataField: "questionTitle",
    text: "پرسش",
    sort: true,
    sortCaret: sortCaret,
  },
  {
    dataField: "questionCode",
    text: "کد پرسش",
    sort: true,
    sortCaret: sortCaret,
  },
  // {
  //   dataField: "questionAnsweredType",
  //   text: "نوع پرسش",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  // {
  //   dataField: "questionAllowedAnswer",
  //   text: "اجازه پاسخ",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  // {
  //   dataField: "isDefault",
  //   text: "پیش فرض",
  //   sort: true,
  //   sortCaret: sortCaret,
  // },
  {
    dataField: "isDeleted",
    text: columnFormatters.translateByMessageId("MODULES.GENERAL.STATUS"),
    sort: true,
    sortCaret: sortCaret,
    formatter: columnFormatters.StatusColumnFormatter,
  },

];

export const formFields = [
  {
    row: 1,
    list: [
      {
        name: "questionId",
        type: "option",
        component: (props) =>
          <FilterSelectObjectsField api="api/question"
            reduxState="questions"
            sname="questionId"
            useInFilter={false}
            label="پرسش" {...props} />,
        placeholder: "پرسش",
        label: "پرسش",
        rowIdx: 2,
        class: "col-lg-6"
      },
      {
        name: "answerId",
        type: "option",
        component: (props) =>
          <SelectObjectsField api="api/Answer"
            reduxState="answers"
            sname="answerId"
            // useInFilter={false}
            label="پاسخ" {...props} />,
        placeholder: "پاسخ",
        label: "پاسخ",
        rowIdx: 3,
        class: "col-lg-6"
      },
    ]
  },

];

export const otherFields = [
  // {
  //   name: "description",
  //   lable: "Description",
  //   type: "textarea",
  //   as: "textarea",
  //   rowOrder: 1,
  //   rowIdx: 1,
  //   class: "form-control"
  // },

];

export const filterFields = [
  {
    name: "isDeleted",
    lable: "MODULES.GENERAL.STATUS",
    type: "select",
    list: [
      {
        value: "",
        lable: "MODULES.GENERAL.STATUSALL",
      },
      {
        value: "0",
        lable: "MODULES.GENERAL.STATUSENABLE",
      },
      {
        value: "1",
        lable: "MODULES.GENERAL.STATUSDELETED",
      },

    ],
    component: SelectStatus
  },
  {
    name: "questionId",
    lable: "پرسش",
    type: "searchComponent",
    list: [],
    component: (props) =>
      <FilterSelectObjectsField
        api="api/question"
        reduxState="questions"
        sname="questionId"
        {...props} />
  },
  {
    name: "answerId",
    lable: "پاسخ",
    type: "component",
    list: [],
    component: (props) =>
      <SelectObjectsField api="api/Answer"
        reduxState="answers"
        sname="answerId"
        {...props} />
  },
  // {
  //   name: "searchText",
  //   lable: "MODULES.GENERAL.SEARCH",
  //   type: "text",
  //   list: [],
  // },

];

export const filterInitialValues = {
  filter: {
    isDeleted: "", // values => All=""/Selling=0/Sold=1
    questionId: 0,
    answerId: 0
  },
  sortOrder: "asc", // asc||desc
  sortField: "id",
  pageNumber: 1,
  pageSize: 10,

  whereClause: "",
  whereClauseParameters: [
  ],
  orderClause: "id desc ",
  skipCount: 0,
  takeCount: 10,
};

export const prepareFilter = (queryParams, values) => {
  const { isDeleted, questionId, answerId } = values;
  const newQueryParams = { ...queryParams };
  const filter = {};
  // Filter by isDeleted
  if (isDeleted !== undefined)
    filter.isDeleted = isDeleted !== "" ? +isDeleted : undefined;

  // Filter by questionId
  filter.questionId = questionId !== "" ? +questionId : 0;
  filter.answerId = answerId !== "" ? +answerId : 0;

  // // Filter by all fields
  // filter.title = searchText;
  // if (searchText) {
  //   filter.title = searchText;
  // }
  newQueryParams.filter = filter;

  let whereClause = ""
  const whereClauseParameters = [];
  var idx = 0;

  if (filter.questionId > 0 && idx === 0) {
    whereClause = `questionId=@${idx}`
    whereClauseParameters.push(filter.questionId)
    idx++;
  }
  else if (filter.questionId > 0 && idx > 0) {
    whereClause = whereClause + ` and questionId=@${idx}`
    whereClauseParameters.push(filter.questionId)
    idx++;
  }

  if (filter.answerId > 0 && idx === 0) {
    whereClause = `answerId=@${idx}`
    whereClauseParameters.push(filter.answerId)
    idx++;
  }
  else if (filter.answerId > 0 && idx > 0) {
    whereClause = whereClause + ` and answerId=@${idx}`
    whereClauseParameters.push(filter.answerId)
    idx++;
  }

  if (filter.isDeleted !== undefined && idx === 0) {
    whereClause = "isDeleted=@0";
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }
  else if (filter.isDeleted !== undefined && idx > 0) {
    whereClause = whereClause + ` and isDeleted=@${idx}`
    whereClauseParameters.push(filter.isDeleted === 0 ? false : true);
    idx++;
  }

  newQueryParams.whereClause = whereClause;
  newQueryParams.whereClauseParameters = whereClauseParameters;

  return newQueryParams;
};


// Validation schema
export const ObjectEditSchema = Yup.object().shape({
  // title: Yup.string()
  //   .required("پر کردن فیلد الزامی است"),
  questionId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),
  answerId: Yup.number()
    .positive("پر کردن فیلد الزامی است"),

});

